module.exports = __webpack_public_path__ + "img/TR-tab.e380747d.jpg";